export default __webpack_public_path__ + "static/Poppins-SemiBold-3971d961e0c4e242c5c7c4eb17fefeba.woff";